"use client";
import { getTranslation } from "@/i18n/get-translation";
import { useEffect } from "react";
import styles from './freshsales-contact-form.module.css';

interface IContactForm {
  locale: string;
}

export default function FreshsalesContactForm({ locale }: IContactForm) {
  const t = getTranslation(locale, "contactUs.contactForm");
  const componentClassPrefix:string = 'freshsales-contact-form';
  const formURLPrefix:string = 'https://medlucy.myfreshworks.com/crm/sales/web_forms/';

  useEffect(()=>{
    if (typeof window !== 'undefined') {
      const script: HTMLScriptElement = document.createElement("script");

      let scriptSrc = `${formURLPrefix}/0e3189085ca214fcac7e5ba44fd65645d0190125dc168d5046b08faab24f61e2/form.js`;
      let scriptId = 'fs_0e3189085ca214fcac7e5ba44fd65645d0190125dc168d5046b08faab24f61e2';

      if(locale === 'fr-lu') {
        scriptSrc = `${formURLPrefix}/b618a92e92afa40d3dbc3ffe5d475cae0b417022219da25d14f65b0dd1c17d1b/form.js`;
        scriptId = 'fs_b618a92e92afa40d3dbc3ffe5d475cae0b417022219da25d14f65b0dd1c17d1b';
      } 
      else if(locale === 'de-lu') {
        scriptSrc = `${formURLPrefix}/1b1844452892d429b9feff53150dc350c446d9f430d9471a83628a91d3ef88aa/form.js`;
        scriptId = 'fs_1b1844452892d429b9feff53150dc350c446d9f430d9471a83628a91d3ef88aa';
      }

      if(!document.getElementById(scriptId)){
        script.src = scriptSrc;
        script.id = scriptId;
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.getElementById("freshsales-form-box")?.appendChild(script);
      }
    }
  },[locale]);

  return (
    <div id="freshsales-form-box" className={styles[componentClassPrefix]}></div>
  );
}
